export const Spinner = () => (
  <div className="spinner" role="status" aria-label="Loading">
    <span />
    <span />
    <span />
    <span />
  </div>
);
